/**
 * @description: 点单首页设置
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="wx-order-home">
        <div class="woh-list" v-show="showList">
            <h1>点单首页设置</h1>
            <p class="p-hint">注：1.点歌首页应用于微信点歌或手机app点歌时，优先进入商家自定义点歌首页内容</p>
            <p class="p-hint">2.排序数值大的排序靠前</p>
            <el-row><el-button type="primary" class="pull-right" @click="wohAdd">新增模块</el-button></el-row>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="woh_table">
                <el-table-column prop="listorder" label="排序"></el-table-column>
                <el-table-column prop="type_name" label="模块类型"></el-table-column>
                <el-table-column prop="name" label="模块名称"></el-table-column>
                <el-table-column prop="show_scene_name" label="显示端"></el-table-column>
                <el-table-column prop="status_name" label="状态"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <span class="text-blue" @click="wohModify(scope.row)">修改</span>
                        <span class="text-blue" @click="wohDel(scope.row.id)">删除</span>
                        <span class="text-blue" @click="wohStatus(scope.row.id)">{{scope.row.status == '1' ? '禁用' : '启用'}}</span>
                        <span class="text-blue" @click="wohModule(scope.row)" v-show="scope.row.can_edit_detail">模块设置</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 新增、修改 -->
        <div class="woh-edit-alert" ref="woh_edit_alert">
            <el-form :model="woh_edit_form" label-width="120px">
                <el-form-item label="模块类型">
                    <el-select v-model="woh_edit_form.type" clearable placeholder="请选择模块类型" :disabled="woh_edit_id !== ''">
                        <el-option v-for="item in woh_type_list" :key="item.type" :label="item.type_name" :value="item.type"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="模块名称">
                    <el-input placeholder="请输入模块名称" v-model="woh_edit_form.name"></el-input>
                </el-form-item>
                <el-form-item label="排序">
                    <el-input placeholder="请输入排序" v-model="woh_edit_form.listorder"></el-input>
                </el-form-item>
                <el-form-item label="显示端">
                    <el-checkbox-group v-model="woh_edit_form.show_scene">
                        <el-checkbox label="1">微信点歌</el-checkbox>
                        <el-checkbox label="2">手机app点歌</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
            </el-form>
        </div>
        <!-- 标题栏、自定义 -->
        <div class="woh-def" v-show="showDef">
            <div class="woh-def-tit" v-show="woh_cur_type == '5'">
                <h2>banner标题栏设置</h2>
                <p class="p-hint">注：1、图片规范：尺寸750x273，如您上传图片不符规范，将不能显示或被压缩<br />2、排序：数字大的排序靠前</p>
            </div>
            <div class="woh-def-tit" v-show="woh_cur_type == '-1'">
                <h2>自定义模块</h2>
                <p class="p-hint">1、图片规范：尺寸704x320，如您上传图片不符规范，将不能显示或被压缩<br />2、排序：数字大的排序靠前</p>
            </div>
            <div class="woh-def-add">
                <el-button type="primary" @click="wohDefAdd">新增图片</el-button>
            </div>
            <div class="woh-def-con">
                <div class="woh-def-item" v-for="(item, index) in woh_def_list" :key="index">
                    <i class="el-icon-error" @click="wohDefDel(index)"></i>
                    <el-form>
                        <el-form-item label="首页图片">
                            <img :src="item.img" :id="item.img_id">
                        </el-form-item>
                        <el-form-item label="排序">
                            <el-input placeholder="请输入排序" v-model="item.listorder"></el-input>
                        </el-form-item>
                        <el-form-item label="点击图片是否进入详情页">
                            <el-select v-model="item.is_entry" placeholder="请选择">
                                <el-option label="是" value="1"></el-option>
                                <el-option label="否" value="-1"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="详情页样式" v-show="item.is_entry == '1'">
                            <el-select v-model="item.detail_style" placeholder="请选择">
                                <el-option label="图片" value="1"></el-option>
                                <el-option label="链接" value="2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="详情页图片" v-show="item.is_entry == '1' && item.detail_style == '1'">
                            <img :src="item.detail_img" :id="item.detail_img_id">
                        </el-form-item>
                        <el-form-item label="详情页链接" v-show="item.is_entry == '1' && item.detail_style == '2'">
                            <el-input
                                type="textarea"
                                :rows="3"
                                placeholder="请输入跳转链接"
                                v-model="item.detail_url"
                            ></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div>
                <el-button @click="backList">返回</el-button>
                <el-button type="primary" @click="wohDefSubmit">保存</el-button>
            </div>
        </div>
        <!-- 闯关游戏 -->
        <div class="woh-game" v-show="showGame">
            <h2>闯关游戏</h2>
            <p class="p-hint">注：可勾选需要显示的控制模块，数字大的排序靠前</p>
            <div class="woh-game-con">
                <div class="woh-game-item" v-for="(item, index) in woh_game_list" :key="index">
                    <el-form>
                        <el-form-item label="勾选模块">
                            <el-checkbox v-model="item.selected">{{item.name}}</el-checkbox>
                        </el-form-item>
                        <el-form-item label="排序">
                            <el-input placeholder="请输入排序" v-model="item.listorder"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <img :src="item.img">
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div>
                <el-button @click="backList">返回</el-button>
                <el-button type="primary" @click="wohGameSubmit">保存</el-button>
            </div>
        </div>
        <!-- 控件 -->
        <div class="woh-widget" v-show="showWidget">
            <h2>控件</h2>
            <p class="p-hint">注：可勾选需要显示的控制模块，数字大的排序靠前</p>
            <div class="woh-widget-con">
                <div class="woh-widget-item" v-for="(item, index) in woh_widget_list" :key="index">
                    <el-form>
                        <el-form-item label="勾选模块">
                            <el-checkbox v-model="item.selected">{{item.name}}</el-checkbox>
                        </el-form-item>
                        <el-form-item label="排序">
                            <el-input placeholder="请输入排序" v-model="item.listorder"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div>
                <el-button @click="backList">返回</el-button>
                <el-button type="primary" @click="wohWidgetSubmit">保存</el-button>
            </div>
        </div>
        <!-- 互动娱乐 -->
        <div class="woh-ita" v-show="showIta">
            <h2>互动娱乐</h2>
            <p class="p-hint">注：可勾选需要显示的控制模块，数字大的排序靠前</p>
            <div class="woh-ita-con">
                <div class="woh-ita-item" v-for="(item, index) in woh_ita_list" :key="index">
                    <el-form>
                        <el-form-item label="勾选模块">
                            <el-checkbox v-model="item.selected">{{item.name}}</el-checkbox>
                        </el-form-item>
                        <el-form-item label="排序">
                            <el-input placeholder="请输入排序" v-model="item.listorder"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="wohItaRule(item.detail)">自定义游戏规则</el-button>
                        </el-form-item>
                        <el-form-item>
                            <img :src="item.img">
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div>
                <el-button @click="backList">返回</el-button>
                <el-button type="primary" @click="wohItaSubmit">保存</el-button>
            </div>
        </div>
        <!-- 自定义游戏规则 -->
        <div class="woh-rule-alert" ref="woh_rule_alert">
            <el-form :model="woh_rule_form">
                <el-form-item label="每个用户每天可玩次数">
                    <el-select v-model="woh_rule_form.play_limit" placeholder="请选择">
                        <el-option label="不限制" value="-1"></el-option>
                        <el-option label="1" value="1"></el-option>
                        <el-option label="2" value="2"></el-option>
                        <el-option label="3" value="3"></el-option>
                        <el-option label="4" value="4"></el-option>
                        <el-option label="5" value="5"></el-option>
                        <el-option label="6" value="6"></el-option>
                        <el-option label="7" value="7"></el-option>
                        <el-option label="8" value="8"></el-option>
                        <el-option label="9" value="9"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <p>颜值起止分定义（0-100分）：设置最高/低分数时，颜值分大于/小于设置的分数，均显示该分数值</p>
                    <el-row>
                        <el-col :span="12">
                            <label class="el-form-item__label">男：</label>
                            <div class="rule-sex-wrap">
                                <el-row>
                                    <label class="el-form-item__label">最高颜值分</label>
                                    <el-input placeholder="分数" v-model="woh_rule_form.male_max_score" class="rule-input-mini"></el-input>
                                </el-row>
                                <el-row>
                                    <label class="el-form-item__label">最低颜值分</label>
                                    <el-input placeholder="分数" v-model="woh_rule_form.male_min_score" class="rule-input-mini"></el-input>
                                </el-row>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <label class="el-form-item__label">女：</label>
                            <div class="rule-sex-wrap">
                                <el-row>
                                    <label class="el-form-item__label">最高颜值分</label>
                                    <el-input placeholder="分数" v-model="woh_rule_form.female_max_score" class="rule-input-mini"></el-input>
                                </el-row>
                                <el-row>
                                    <label class="el-form-item__label">最低颜值分</label>
                                    <el-input placeholder="分数" v-model="woh_rule_form.female_min_score" class="rule-input-mini"></el-input>
                                </el-row>
                            </div>
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item>
                    <p>分数区间评语及奖品设置</p>
                    <div class="woh-rule-item" v-for="(item, index) in woh_rule_form.grade_rule" :key="index">
                        <el-row>
                            <label class="el-form-item__label">{{item.min_score}}-{{item.max_score}}分</label>
                            <label class="el-form-item__label">评语</label>
                            <el-input placeholder="请输入评语" v-model="item.comment"></el-input>
                            <el-button type="primary" class="pull-right" @click="rulePrizesAdd(index)">新增奖品券</el-button>
                        </el-row>
                        <el-table
                            :data="item.gift_info">
                            <el-table-column prop="satisfy_shop_name" label="活动券适用门店"></el-table-column>
                            <el-table-column prop="gift_name" label="活动券名称"></el-table-column>
                            <el-table-column label="活动券数量">
                                <template slot-scope="scope">
                                    <el-input placeholder="请输入正整数" v-model="item.gift_info[scope.$index].quantity" class="rule-table-input" @blur="ruleCouponQuantity($event, index, scope.$index, scope.row.quantity)"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <span class="text-blue" @click="rulePrizesDel(index, scope.$index)">删除</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-form-item>
            </el-form>
        </div>
        <!-- 添加奖品 -->
        <div class="select-goods-wrap" ref="rule_coupon_alert">
            <el-row :gutter="20">
                <el-col :span="8">
                    <el-select v-model="coupon_type" clearable filterable placeholder="请选择类型" @change="couponTypeChange">
                        <el-option label="优惠券" value="1"></el-option>
                        <el-option label="商品券" value="2"></el-option>
                        <el-option label="商品套餐券" value="3"></el-option>
                        <el-option label="开房套餐券" value="4"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="10">
                    <el-input placeholder="请输入活动券名称" v-model="coupon_name"></el-input>
                </el-col>
                <el-col :span="6">
                    <el-button class="pull-right" type="primary" @click="getCouponTable(1)">查询</el-button>
                </el-col>
            </el-row>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                ref="coupon_table"
                :data="coupon_table"
                @selection-change="getCouponSelect">
                <el-table-column type="selection"></el-table-column>
                <el-table-column prop="type_name" label="类型"></el-table-column>
                <el-table-column prop="name" label="名称"></el-table-column>
                <el-table-column prop="satisfy_shop_name" label="活动券适用门店"></el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZEMINI"
                :current-page.sync="coupon_page"
                :total="coupon_total"
                @current-change="getCouponTable">
            </el-pagination>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                loading: false,
                woh_type_list: [],
                showList: true,

                woh_table: [],
                woh_edit_id: '',
                woh_edit_tit: '',
                woh_edit_form: {
                    type: '',
                    name: '',
                    listorder: '',
                    show_scene: []
                },

                showDef: false,
                showGame: false,
                showWidget: false,
                showIta: false,
                woh_cur_type: '',
                woh_cur_id: '',
                woh_def_list: [],
                woh_game_list: [],
                woh_widget_list: [],
                woh_ita_list: [],
                woh_rule_form: {},
                coupon_type: '',
				coupon_name: '',
				coupon_page: 1,
				coupon_total: 0,
                coupon_table: [],
                coupon_table_select: [],
            }
        },
        mounted: function() {
            this.getWohTable()
            this.getModuleType()
        },
        methods: {
            getModuleType() {
                const _this = this;

				Vue.axios.post('WxHomePage/getModuleTypeList', {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						_this.woh_type_list = res.data.response.result
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this)
						layer.msg(res.data.response.error_msg)
					}
				})
				.catch(err => {
					layer.msg('出错啦')
				})
            },



            // 列表
			getWohTable() {
				const _this = this

				_this.loading = true
				Vue.axios.post('WxHomePage/getModuleList', {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						_this.woh_table = res.data.response.result
						_this.loading = false
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦")
				})
            },
            // 删除
			wohDel(id) {
				const _this = this;

				layer.confirm('删除后不可恢复，确定删除吗？', {
					btn: ['确定', '取消']
				}, function() {
					Vue.axios.post('WxHomePage/deleteModule', {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
                                "id": id
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('删除成功')
							_this.getWohTable()
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg('出错啦');
					})
				})
            },
            // 启用、禁用
            wohStatus(id) {
				const _this = this;

				layer.confirm('确定执行操作吗？', {
					btn: ['确定', '取消']
				}, function() {
					Vue.axios.post('WxHomePage/setModuleStatus', {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
                                "id": id
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('操作成功')
							_this.getWohTable()
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg('出错啦');
					});
				})
            },
            // 点击新增
			wohAdd() {
                this.woh_edit_id = ''
                this.woh_edit_form = {
                    type: '',
                    name: '',
                    listorder: '',
                    show_scene: ['1', '2']
                }
                this.wohEdit('新增模块')
			},
			// 点击修改
			wohModify(row) {
                this.woh_edit_id = row.id
                this.woh_edit_form = {
                    type: row.type,
                    name: row.name,
                    listorder: row.listorder,
                    show_scene: row.show_scene
                }
                this.wohEdit('修改模块')
            },
            // 新增、修改
			wohEdit(tit) {
                const _this = this;

                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: [tit, true],
                    area: ['600px', ''], // 宽高
                    content: $(_this.$refs.woh_edit_alert)
                }, function() {
                    let data = {
                        "header": Vue.request_header,
                        "request": {
                            "param": {
                                "type": _this.woh_edit_form.type,
                                "name": _this.woh_edit_form.name,
                                "listorder": _this.woh_edit_form.listorder,
                                "show_scene": _this.woh_edit_form.show_scene
                            }
                        },
                        "comment": ""
                    };
                    if(_this.woh_edit_id) {
                        data.request.param.id = _this.woh_edit_id
                    }
                    Vue.axios({
                        method: 'post',
                        url: 'WxHomePage/editModule',
                        data: data
                    })
                    .then(res => {
                        if(res.data.response.result_code == "true") {
                            layer.closeAll()
                            layer.msg('操作成功')
                            _this.getWohTable()
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg("出错啦");
                    });
                });
            },
            // 模块设置
            wohModule(row) {
                const _this = this

                _this.woh_cur_type = row.type
                _this.woh_cur_id = row.id
                Vue.axios.post('WxHomePage/getModuleDetail', {
					"header": Vue.request_header,
					"request": {
						"param": {
                            id: row.id
                        }
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
                        _this.showList = false
						if(row.type == '5' || row.type == '-1') {
                            _this.woh_def_list = []
                            _this.$nextTick(() => {
                                res.data.response.result.forEach((v, k) => {
                                    _this.woh_def_list.push({
                                        img: v.img,
                                        img_id: 'defImg' + k,
                                        img_done: true,
                                        listorder: v.listorder,
                                        is_entry: '-1',
                                        detail_style: '1',
                                        detail_img: require('../../assets/images/upload_btn.png'),
                                        detail_img_id: 'defDetailImg' + k,
                                        detail_img_done: false,
                                        detail_url: ''
                                    })
                                    _this.wohDefImgUpload('defImg' + k, k, 'img')
                                    _this.wohDefImgUpload('defDetailImg' + k, k, 'detail_img')
                                    if(v.detail_img != '' || v.detail_url != '') {
                                        _this.woh_def_list[k].is_entry = '1'
                                        if(v.detail_img == '') {
                                            _this.woh_def_list[k].detail_style = '2'
                                            _this.woh_def_list[k].detail_url = v.detail_url
                                        } else if(v.detail_url == '') {
                                            _this.woh_def_list[k].detail_img = v.detail_img
                                            _this.woh_def_list[k].detail_img_done = true
                                        }
                                    }
                                })
                            })
                            _this.showDef = true
                        } else if(row.type == '2') {
                            _this.woh_game_list = res.data.response.result
                            _this.showGame = true
                        } else if(row.type == '6') {
                            _this.woh_widget_list = res.data.response.result
                            _this.showWidget = true
                        } else if(row.type == '7') {
                            _this.woh_ita_list = res.data.response.result
                            _this.showIta = true
                        }
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this)
						layer.msg(res.data.response.error_msg)
					}
				})
				.catch(err => {
					layer.msg('出错啦')
				})
            },
            // 返回
            backList() {
                this.showList = true
                this.showDef = false
                this.showGame = false
                this.showWidget = false
                this.showIta = false
            },
            // 新增图片
            wohDefAdd() {
                const index = this.woh_def_list.length,
                    img_id = 'defImg' + index,
                    detail_img_id = 'defDetailImg' + index

                this.woh_def_list.push({
                    img: require('../../assets/images/upload_btn.png'),
                    img_id: img_id,
                    img_done: false,
                    listorder: '',
                    is_entry: '-1',
                    detail_style: '1',
                    detail_img: require('../../assets/images/upload_btn.png'),
                    detail_img_id: detail_img_id,
                    detail_img_done: false,
                    detail_url: ''
                })
                this.wohDefImgUpload(img_id, index, 'img')
                this.wohDefImgUpload(detail_img_id, index, 'detail_img')
            },
            // 删除图片
            wohDefDel(index) {
                const _this = this;

				layer.confirm('删除后不可恢复，确定删除吗？', {
					btn: ['确定', '取消']
				}, function() {
                    const arr = [..._this.woh_def_list]
                    arr.splice(index, 1)
                    _this.woh_def_list = []
                    // this.uploader_list = []
                    _this.$nextTick(() => {
                        arr.forEach((v, k) => {
                            _this.woh_def_list.push({
                                img: v.img,
                                img_id: 'defImg' + k,
                                img_done: v.img_done,
                                listorder: v.listorder,
                                is_entry: v.is_entry,
                                detail_style: v.detail_style,
                                detail_img: v.detail_img,
                                detail_img_id: 'defDetailImg' + k,
                                detail_img_done: v.detail_img_done,
                                detail_url: v.detail_url
                            })
                            _this.wohDefImgUpload('defImg' + k, k, 'img')
                            _this.wohDefImgUpload('defDetailImg' + k, k, 'detail_img')
                        })
                    })
                    layer.closeAll()
				})
            },
            // 上传图片
			wohDefImgUpload: function(id, index, type) {
				const _this = this;
				let host = '',
					dir = '',
					file_name = '';

                // if(_this.uploader_list.includes(id)) {
				// 	return false
				// } else {
				// 	_this.uploader_list.push(id)
				// }
                let rwidth = 750,
                    rheight = 273
                if(_this.woh_cur_type == '-1') {
                    rwidth = 704
                    rheight = 320
                }
				setTimeout(function() {
					// 实例化一个plupload上传对象
					let uploader = new plupload.Uploader({
						browse_button: id, // 选择文件id
						filters: {
							mime_types: [ // 文件格式限制
								{ title: "Image files", extensions: "jpg,jpeg,png,gif" }
							],
							// max_file_size: '2mb', // 文件大小限制
							prevent_duplicates: true // 不允许选取重复文件
						},
						resize: {
							width: rwidth,
							height: rheight
						},
						multi_selection: false, // 单选
						url: './', // OSS地址
						init: {
							// 文件上传前触发
							BeforeUpload: function(up, file) {},
							// 文件选择完毕触发
							FilesAdded: function(up, files) {
								// 获取签名
								Vue.axios.post('publicData/api_getOssSignature', {
									"header": Vue.request_header,
									"request": {
										"version": Vue.version,
										"param": {
											"file": files[0].name,
											"path": 'system_set'
										}
									},
									"comment": ""
								})
								.then(res => {
									if(res.data.response.result_code == "true") {
										host = res.data.response.data.host;
										dir = res.data.response.data.dir;
										file_name = res.data.response.data.file_name;
										const new_params = {
											'key': dir + file_name,
											'OSSAccessKeyId': res.data.response.data.accessid,
											'policy': res.data.response.data.policy,
											'signature': res.data.response.data.signature,
											'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
										};
										up.setOption({
											'url': host,
											'multipart_params': new_params
										});

										// 上传文件
										uploader.start();
									} else {
										Vue.timeoutfun(data.response.result_status, _this);
										layer.msg(data.response.error_msg);
									}
								})
								.catch(err => {
									layer.msg("出错啦");
								});
							},
							// 文件上传成功触发
							FileUploaded: function(up, file, data) {
                                if(type == 'img') {
                                    _this.woh_def_list[index].img = host + "/" + dir + file_name
                                    _this.woh_def_list[index].img_done = true
                                } else if(type == 'detail_img') {
                                    _this.woh_def_list[index].detail_img = host + "/" + dir + file_name
                                    _this.woh_def_list[index].detail_img_done = true
                                }
								layer.msg('上传成功')
							},
							// 错误提示
							Error: function(up, err) {
								if(err.code == -600) {
									layer.msg('请选择2mb以内的文件');
								} else if (err.code == -601) {
									layer.msg('只允许上传jpg,jpeg,png,gif文件');
								} else if (err.code == -602) {
									layer.msg('这个文件已经上传过一遍了');
								} else {
									layer.msg(err.response);
								}
							}
						}
					});
					// 初始化
					uploader.init();
				}, 20);
            },
            wohDefSubmit() {
                const _this = this

                let imgTrue = true,
                    listorderTrue = true,
                    detailImgTrue = true,
                    detailUrlTrue = true
                for(let i = 0; i < _this.woh_def_list.length; i++) {
                    if(!_this.woh_def_list[i].img_done) {
                        imgTrue = false
                    }
                    if(_this.woh_def_list[i].listorder == '') {
                        listorderTrue = false
                    }
                    if(_this.woh_def_list[i].is_entry == '1' && _this.woh_def_list[i].detail_style == '1' && !_this.woh_def_list[i].detail_img_done) {
                        detailImgTrue = false
                    }
                    if(_this.woh_def_list[i].is_entry == '1' && _this.woh_def_list[i].detail_style == '2' && _this.woh_def_list[i].detail_url == '') {
                        detailUrlTrue = false
                    }
                }
                if(!imgTrue) {
                    layer.msg('请上传首页图片')
                    return false
                } else if(!listorderTrue) {
                    layer.msg('请输入排序')
                    return false
                } else if(!detailImgTrue) {
                    layer.msg('请上传详情页图片')
                    return false
                } else if(!detailUrlTrue) {
                    layer.msg('请输入跳转链接')
                    return false
                }
                const detail = []
                _this.woh_def_list.forEach(_ => {
                    if(_.is_entry == '1') {
                        if(_.detail_style == '1') {
                            detail.push({
                                "img": _.img,
                                "listorder": _.listorder,
                                "detail_img": _.detail_img,
                                "detail_url": ""
                            })
                        } else if(_.detail_style == '2') {
                            detail.push({
                                "img": _.img,
                                "listorder": _.listorder,
                                "detail_img": "",
                                "detail_url": _.detail_url
                            })
                        }
                    } else if(_.is_entry == '-1') {
                        detail.push({
                            "img": _.img,
                            "listorder": _.listorder,
                            "detail_img": "",
                            "detail_url": ""
                        })
                    }
                })
                Vue.axios.post('WxHomePage/editModuleDetail', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"id": _this.woh_cur_id,
                            "detail": detail
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						layer.msg('保存成功')
                        _this.showList = true
                        _this.showDef = false
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },
            // 闯关游戏提交
            wohGameSubmit() {
                const _this = this

                const detail = []
                _this.woh_game_list.forEach(_ => {
                    if(_.selected) {
                        detail.push({
                            "id": _.id,
                            "listorder": _.listorder
                        })
                    }
                })
                Vue.axios.post('WxHomePage/editModuleDetail', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"id": _this.woh_cur_id,
                            "detail": detail
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						layer.msg('保存成功')
                        _this.showList = true
                        _this.showGame = false
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				})
            },
            // 控件设置提交
            wohWidgetSubmit() {
                const _this = this

                const detail = []
                _this.woh_widget_list.forEach(_ => {
                    if(_.selected) {
                        detail.push({
                            "id": _.id,
                            "listorder": _.listorder
                        })
                    }
                })
                Vue.axios.post('WxHomePage/editModuleDetail', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"id": _this.woh_cur_id,
                            "detail": detail
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						layer.msg('保存成功')
                        _this.showList = true
                        _this.showWidget = false
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				})
            },
            // 互动娱乐提交
            wohItaSubmit() {
                const _this = this

                const detail = []
                _this.woh_ita_list.forEach(_ => {
                    if(_.selected) {
                        detail.push({
                            "id": _.id,
                            "listorder": _.listorder
                        })
                    }
                })
                Vue.axios.post('WxHomePage/editModuleDetail', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"id": _this.woh_cur_id,
                            "detail": detail
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						layer.msg('保存成功')
                        _this.showList = true
                        _this.showIta = false
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				})
            },
            // 自定义游戏规则
            wohItaRule(obj) {
                const _this = this

                _this.woh_rule_form = obj
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['自定义规则', true],
                    area: ['700px', '500px'], // 宽高
                    content: $(_this.$refs.woh_rule_alert)
                }, function() {
                    Vue.axios.post('AmusementModuleManage/setDetectFaceRule', {
                        "header": Vue.request_header,
                        "request": {
                            "param": {
                                detail: _this.woh_rule_form
                            }
                        },
                        "comment": ""
                    })
                    .then(res => {
                        if(res.data.response.result_code == "true") {
                            layer.closeAll()
                            layer.msg('保存成功')
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg("出错啦");
                    })
                });
            },
            // 添加奖品
			rulePrizesAdd: function(index) {
				const _this = this;

				_this.coupon_type = ''
				_this.coupon_name = ''
				_this.coupon_page = 1
				_this.getCouponTable(1)
				layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['添加活动券', true],
                    area: ['710px', '500px'], // 宽高
                    content: $(_this.$refs.rule_coupon_alert)
                }, function() {
                    // 保存活动券
                    _this.coupon_table_select.forEach(_ => {
                        let isTrue = true;
                        for(let i = 0; i < _this.woh_rule_form.grade_rule[index].gift_info.length; i++) {
                            if(_this.woh_rule_form.grade_rule[index].gift_info[i].gift_id == _.id) {
                                isTrue = false
                                return false
                            }
                        }
                        if(isTrue) {
                            _this.woh_rule_form.grade_rule[index].gift_info.push({
                                "gift_id": _.id,
                                "satisfy_shop_name": _.satisfy_shop_name,
                                "gift_name": _.name,
                                "quantity": 1
                            })
                            console.log(_this.woh_rule_form.grade_rule[index].gift_info)
                        }
                    })
                    layer.msg('保存成功')
                    _this.$refs.coupon_table.clearSelection();
                });
			},
			rulePrizesDel(i, j) {
				this.woh_rule_form.grade_rule[i].gift_info.splice(j, 1)
			},
			couponTypeChange(val) {
				this.getCouponTable(1);
			},
			getCouponTable: function(page) {
				const _this = this;

				_this.loading = true;
                Vue.axios.post('MerchantGift/getListToTicket', {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZEMINI,
							// "shop_id": _this.woh_rule_form.shop_id,
							"type": _this.coupon_type,
							"name": _this.coupon_name
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.coupon_total = Number(res.data.response.result.total);
						}
						_this.coupon_table = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
			getCouponSelect(val) {
				this.coupon_table_select = val
            },
            ruleCouponQuantity(val, i, j, quantity) {
                if(!/^[1-9]\d*$/.test(quantity)) {
                    layer.msg('请输入正整数')
                    this.woh_rule_form.grade_rule[i].gift_info[j].quantity = 1
                }
            },
        }
    }
</script>
<style lang="less" scoped>
    .woh-edit-alert {
        display: none;
        .el-select {
            width: 100%;
        }
    }
    .woh-def-add {
        margin: 30px 0;
    }
    .woh-def-con {
        display: flex;
        justify-content: space-between;
        flex-flow: wrap;
        .woh-def-item {
            position: relative;
            width: 500px;
            height: 500px;
            padding: 20px;
            margin: 0 0 50px;
            background: #f5f5f5;
            .el-icon-error {
                position: absolute;
                right: -15px;
                top: -15px;
                color: #409eff;
                font-size: 30px;
                cursor: pointer;
            }
            .el-input {
                width: auto;
            }
            .el-textarea {
                width: 365px;
            }
            img {
                display: block;
                width: 114px;
                height: 114px;
                cursor: pointer;
            }
        }
    }
    .woh-game-con {
        display: flex;
        flex-flow: wrap;
        .woh-game-item {
            padding: 20px;
            margin: 0 0 30px;
            background: #f5f5f5;
            .el-input {
                width: auto;
            }
            img {
                display: block;
                width: 272px;
                // height: 155px;
            }
        }
    }
    .woh-widget-con {
        display: flex;
        flex-flow: wrap;
        .woh-widget-item {
            width: 272px;
            padding: 20px;
            margin: 0 30px 30px 0;
            background: #f5f5f5;
            .el-input {
                width: auto;
            }
        }
    }
    .woh-ita-con {
        display: flex;
        flex-flow: wrap;
        .woh-ita-item {
            padding: 20px;
            margin: 0 0 30px;
            background: #f5f5f5;
            .el-input {
                width: auto;
            }
            img {
                display: block;
                width: 272px;
                // height: 155px;
            }
        }
    }
    .woh-rule-alert {
        display: none;
        p {
            border-top: 1px solid #ccc;
        }
        .rule-sex-wrap {
            margin-left: 40px;
            .rule-input-mini {
                width: 83px;
            }
        }
        .woh-rule-item {
            border: 1px solid #ccc;
            padding: 10px 20px;
            margin: 0 0 20px;
            .el-input {
                width: 350px;
            }
            .rule-table-input {
                width: 100px;
            }
        }
    }
    .select-goods-wrap {
        display: none;
    }
</style>